import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePostRequest } from "../../services/PostTemplate";
import { handlePutRequest } from "../../services/PutTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as Yup from "yup";
import { Dialog } from "primereact/dialog";
import AcceptRejectComment from "./AcceptRejectComment";
import ZDropdown from "../../components/zDropdown/ZDropdown";
import { v4 as uuidv4 } from "uuid";
import { useHistory } from "react-router-dom";

function BranchUser() {
  const history = useHistory();

  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("pi pi-save");
  const [branch, setBranch] = useState([]);
  const [selectedRow, setselectedRow] = useState("");
  const [editFlag, setEditFlag] = useState(false);
  const [displayModal, setDisplayModal] = useState(false);
  const [branchUserDetails, setBranchUserDetails] = useState({
    userId: "",
    mcStatus: "",
    checkerComments: "",
  });
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  useEffect(() => {
    if (
      selectedRow !== null &&
      selectedRow !== undefined &&
      selectedRow !== ""
    ) {
      setloading(false);
      setEditFlag(true);
      branchFormFill();
    }
  }, [selectedRow]);

  useEffect(() => {
    setEditFlag(false);
  }, []);

  const branchFormFill = () => {
    formik.setFieldValue("contactNo", selectedRow?.contactNo?.toString());
    formik.setFieldValue("designation", selectedRow?.designation?.toString());
    formik.setFieldValue("email", selectedRow?.email?.toString());
    formik.setFieldValue("employeeNo", selectedRow?.employeeNo?.toString());
    formik.setFieldValue("userCode", selectedRow?.userCode?.toString());
    formik.setFieldValue("cnic", selectedRow?.cnic?.toString());
    formik.setFieldValue("userName", selectedRow?.userName?.toString());
    formik.setFieldValue("roleId", selectedRow?.roleId?.toString());
  };

  const getBranch = async () => {
    setloading(true);
    const response = await handleGetRequest(
      "zbizgateway/nonFin/getAllBranchUsers"
    );
    setBranch(response?.data);
    setloading(false);
  };

  useEffect(() => {
    getBranch();
  }, []);

  const handleApproveRejectSubmit = (e) => {
    e.preventDefault();
    handlePutRequest(
      branchUserDetails,
      "zbizgateway/nonFin/updateAuthorizeBranchUser"
    );
  };

  const cancelHandler = (e) => {
    e.preventDefault();
    setEditFlag(false);
    formik.resetForm();
  };
  const commentHandler = (comment) => {
    setBranchUserDetails({ ...branchUserDetails, checkerComments: comment });
  };

  // const handleApproveReject = (data, mcStatus) => {
  //   setBranchUserDetails({
  //     ...branchUserDetails,
  //     userId: data?.userId,
  //     mcStatus,
  //   });
  //   setDisplayModal(true);
  // };
  // const actionTemplate = (rowData) => {
  //   return (
  //     <div className="Action__Wrapper">
  //       <Button
  //         className="p-button-rounded p-button-outlined"
  //         tooltip="Approve"
  //         value="Approve"
  //         icon="pi pi-check mr-2"
  //         tooltipOptions={{ position: "top" }}
  //         onClick={() => {
  //           handleApproveReject(rowData, "A");
  //         }}
  //       />
  //       <Button
  //         className="p-button-rounded p-button-danger p-button-outlined"
  //         value="Reject"
  //         tooltip="Reject"
  //         icon="pi pi-times"
  //         tooltipOptions={{ position: "top" }}
  //         onClick={() => {
  //           handleApproveReject(rowData, "R");
  //         }}
  //       />
  //     </div>
  //   );
  // };

  const validationSchema = Yup.object().shape({
    contactNo: Yup.string()
      .required("This field is required.")
      .matches(
        /^03\d{9}$/,
        'Contact number must start with "03" and be exactly 11 digits.'
      ),
    designation: Yup.string()
      .max(50, "Maximum length 50 allowed")
      .required("This field is required."),
    email: Yup.string()
      .email("Invalid email address format")
      .required("This field is required."),
    roleId: Yup.mixed().required("This field is required."),
    // userCode: Yup.string()
    //   .required("This field is required")
    //   .max(20, "Maximum length 20 allowed")
    //   .matches("^[0-9]*$", "Please enter numeric data"),
    employeeNo: Yup.string()
      .required("This field is required")
      .max(20, "Maximum length 20 allowed")
      .matches("^[0-9]*$", "Please enter numeric data"),
    // userName: Yup.string().max(100, "Maximum length 100 allowed"),
    cnic: Yup.string()
      .max(13, "Maximum length 13 allowed")
      .matches("^[0-9]*$", "Please enter numeric data")
      .min(13, "Minimum length 13 required"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      contactNo: "",
      designation: "",
      email: "",
      roleId: "",
      employeeNo: "",
      // userCode: "",
      cnic: "",
      // userName: "",
      checkerComments: "",
    },
    onSubmit: async (data) => {
      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        data["userName"] = formik.values.email;
        const uuId = uuidv4();
        const uniqueId = uuId.split("-");

        if (editFlag) {
          data["userId"] = selectedRow?.userId;
          const res = await handlePutRequest(
            data,
            "zbizgateway/nonFin/updateBranchUser"
          );

          if (res?.status === 400) {
            res?.data.forEach((element) => {
              formik.setFieldError(element?.field, element?.message);
            });
          } else {
            formik.resetForm();
            setEditFlag(false);
          }
        } else {
          data["userCode"] = uniqueId[4].slice(0, 5);
          const res = await handlePostRequest(
            data,
            "zbizgateway/nonFin/saveBranchUser"
          );

          if (res?.status === 400) {
            res?.data.forEach((element) => {
              formik.setFieldError(element?.field, element?.message);
            });
          } else {
            // formik.resetForm();
          }
        }

        await getBranch();
      } catch (error) {
        console.error("Error during submission:", error);
      } finally {
        setloading(false);
        setloadingIcon("pi pi-save");
        formik.resetForm();
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const statusTemplate = (rowData) => {
    return (
      <React.Fragment>
        <span
          className={
            rowData.isActive === "Y"
              ? "p-badge p-badge-success"
              : "p-badge p-badge-danger"
          }
        >
          {rowData?.isActive === "Y" ? "Active" : "Inactive"}
        </span>
      </React.Fragment>
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  return (
    <>
      <Dialog
        visible={displayModal}
        header={`${
          branchUserDetails?.mcStatus === "A" ? "Approve" : "Reject"
        } Comments`}
        style={{ width: "50vw" }}
        onHide={() => setDisplayModal(false)}
      >
        <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
          <div className="card Card__Round">
            <div className="Form__Header">
              <AcceptRejectComment handlCommentHandler={commentHandler} />
              <div className="Down__Btn">
                <Button
                  disabled={loading}
                  onClick={(e) => handleApproveRejectSubmit(e)}
                  label={
                    branchUserDetails?.mcStatus === "A" ? "Approve" : "Reject"
                  }
                  className="Btn__Dark"
                />
              </div>
            </div>
          </div>
        </form>
      </Dialog>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">User Creation</h3>
          </div>
        </div>
      </div>
      <div className="card Card__Round">
        <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
          <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-4">
              <div className="p-field input_cp">
                <label
                  htmlFor="designation"
                  className={classNames(
                    { "p-error": isFormFieldValid("designation") },
                    "Label__Text"
                  )}
                >
                  Designation<span className="Label__Required">*</span>
                </label>
                <InputText
                  id="designation"
                  placeholder=""
                  name="designation"
                  value={formik.values.designation}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("designation") },
                    "input_text"
                  )}
                />

                {getFormErrorMessage("designation")}
              </div>
            </div>
            <div className="p-field p-col-12 p-md-4">
              <div className="p-field input_cp">
                <label
                  htmlFor="contactNo"
                  className={classNames(
                    { "p-error": isFormFieldValid("contactNo") },
                    "Label__Text"
                  )}
                >
                  Contact No<span className="Label__Required">*</span>
                </label>
                <InputText
                  id="contactNo"
                  placeholder="03XXXXXXXXX"
                  name="contactNo"
                  value={formik.values.contactNo}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("contactNo") },
                    "input_text"
                  )}
                  keyfilter={/^[0-9]+$/}
                />

                {getFormErrorMessage("contactNo")}
              </div>
            </div>
            <div className="p-field p-col-12 p-md-4">
              <div className="p-field input_cp">
                <label
                  htmlFor="email"
                  className={classNames(
                    { "p-error": isFormFieldValid("email") },
                    "Label__Text"
                  )}
                >
                  Email<span className="Label__Required">*</span>
                </label>
                <InputText
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("email") },
                    "input_text"
                  )}
                />

                {getFormErrorMessage("email")}
              </div>
            </div>

            <div className="p-field p-col-12 p-md-4">
              <div className="p-field input_cp">
                <label
                  htmlFor="employeeNo"
                  className={classNames(
                    { "p-error": isFormFieldValid("employeeNo") },
                    "Label__Text"
                  )}
                >
                  Employee No.<span className="Label__Required">*</span>
                </label>
                <InputText
                  id="employeeNo"
                  placeholder=""
                  name="employeeNo"
                  value={formik.values.employeeNo}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("employeeNo") },
                    "input_text"
                  )}
                />

                {getFormErrorMessage("employeeNo")}
              </div>
            </div>

            <div className="p-field p-col-12 p-md-4">
              <div className="p-field input_cp">
                <label
                  htmlFor="userName"
                  className={classNames(
                    { "p-error": isFormFieldValid("userName") },
                    "Label__Text"
                  )}
                >
                  User Name
                </label>
                <InputText
                  id="email"
                  placeholder=""
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  className="input_text"
                  disabled
                />

                {getFormErrorMessage("userName")}
              </div>
            </div>
            <div className="p-field p-col-12 p-md-4">
              <div className="p-field input_cp">
                <label
                  htmlFor="cnic"
                  className={classNames(
                    { "p-error": isFormFieldValid("cnic") },
                    "Label__Text"
                  )}
                >
                  CNIC
                </label>
                <InputText
                  id="cnic"
                  placeholder="Enter CNIC without dash"
                  name="cnic"
                  value={formik.values.cnic}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("cnic") },
                    "input_text"
                  )}
                />

                {getFormErrorMessage("cnic")}
              </div>
            </div>
            <div className="p-field p-col-12 p-md-4">
              <div className="p-field input_cp">
                <ZDropdown
                  {...props}
                  label="Role"
                  required
                  valueOption="id"
                  keyName="roleId"
                  placeholder="Select Role"
                  optionLabel="description"
                  url="zbizgateway/lov/lovRole"
                />
              </div>
            </div>
          </div>
          {/* <div className="Down__Btn">
            <Button
              label="Cancel"
              className="Btn__Transparent"
              onClick={(e) => cancelHandler(e)}
            />
            <Button
              disabled={loading}
              icon={loadingIcon || ""}
              iconPos="right"
              label={editFlag ? "Update" : "Add"}
              className="Btn__Dark"
            />
          </div> */}
          <div className="GenerateDown__Btn p-mt-4">
            <Button
              className="Btn__Transparent"
              label={editFlag ? "Update" : "Add"}
              disabled={loading}
            />
            <Button
              className="Btn__Dark"
              label="Cancel"
              onClick={(e) => cancelHandler(e)}
            />
          </div>
        </form>
      </div>

      <div className="card p-datatable-sm">
        <DataTable
          // header="User Creation"
          selection={selectedRow}
          onSelectionChange={(e) => setselectedRow(e.value)}
          selectionMode="single"
          dataKey="userId"
          loading={loading}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          value={branch}
          emptyMessage="No data found."
        >
          <Column filter field="userCode" header="User Code" />
          <Column filter field="userName" header="User Name" />
          <Column filter field="contactNo" header="Contact No" />
          <Column filter field="designation" header="Designation" />
          <Column filter field="roleName" header="Role" />
          <Column
            field="status"
            filterField={(rowData) =>
              rowData?.isActive === "Y" ? "Active" : "Inactive"
            }
            header="Status"
            body={statusTemplate}
            filter
            filterMatchMode="contains"
          />
          {/* <Column body={actionTemplate} header="Action" /> */}
        </DataTable>
      </div>
      <br />
    </>
  );
}

export default BranchUser;
